import { createNamespacedHelpers } from 'vuex'

const { mapGetters, mapActions } = createNamespacedHelpers('branding')

export const BrandingComputed = {
  ...mapGetters({
    branding: 'branding',
    motadataCompanyLogo: 'logo',
    companyFavicon: 'favicon',
    darkThemeLogo: 'darkThemeLogo',
    supportPortalBackground: 'supportPortalBackground',
    productSetupGuideBackground: 'productSetupGuideBackground',
    linkbackUrl: 'linkbackUrl',
    guestUserLandingPage: 'guestUserLandingPage',
  }),
}

export const BrandingMethods = mapActions({
  updateBranding: 'updateBranding',
  fetchBranding: 'fetch',
})
